import React from 'react';
import { ListGroup, Button, Dropdown, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faTrash } from '@fortawesome/free-solid-svg-icons';

function SortController({ columns, sorting, setSorting }) {
  const availableColumns = columns.filter(
    (col) => col.getCanSort() && !sorting.find((s) => s.id === col.id)
  );

  const addSort = (columnId) => {
    setSorting([...sorting, { id: columnId, desc: false }]);
  };

  const removeSort = (columnId) => {
    setSorting(sorting.filter((s) => s.id !== columnId));
  };

  const toggleSortDirection = (columnId) => {
    setSorting(
      sorting.map((s) =>
        s.id === columnId ? { ...s, desc: !s.desc } : s
      )
    );
  };

  return (
    <div className="p-2">
      <h6 className="fw-bold">Ordinamento</h6>
      {sorting.length > 0 ? (
        <ListGroup variant="flush">
          {sorting.map((sort, index) => {
            const column = columns.find((c) => c.id === sort.id);
            return (
              <ListGroup.Item key={sort.id} className="d-flex justify-content-between align-items-center p-1">
                <span>
                  {index + 1}. {column?.columnDef.header}
                </span>
                <ButtonGroup size="sm">
                  <Button
                    variant="outline-secondary"
                    onClick={() => toggleSortDirection(sort.id)}
                  >
                    <FontAwesomeIcon icon={sort.desc ? faSortDown : faSortUp} />
                  </Button>
                  <Button
                    variant="outline-danger"
                    onClick={() => removeSort(sort.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </ButtonGroup>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      ) : (
        <p className="text-muted small">Nessun criterio di ordinamento applicato.</p>
      )}

      <Dropdown className="mt-2" as={ButtonGroup}>
        <Button
          variant="primary"
          size="sm"
          disabled={availableColumns.length === 0}
        >
          Aggiungi ordinamento
        </Button>
        <Dropdown.Toggle
          split
          variant="primary"
          size="sm"
          disabled={availableColumns.length === 0}
        />
        <Dropdown.Menu>
          {availableColumns.map((col) => (
            <Dropdown.Item key={col.id} onClick={() => addSort(col.id)}>
              {col.columnDef.header}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default SortController;
